@if (isVisible() && !cookieConsentService.hasConsent()) {
<lib-consent-banner (onConsentGranted)="handleConsent()" (onRejected)="handleDenial()">
  <p>We use cookies to enhance your experience and analyze website usage. Specifically, we utilize Microsoft
    Clarity
    to collect anonymous data on user interactions and track session activity. This helps us improve the
    functionality and usability of our application. Learn more in our <a href="https://www.studio2wx.com/legal-notice/#privacy-policy" target="_blank">Privacy Policy</a>.
  </p>
</lib-consent-banner>
}
